import { useQueryWithUserId } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

/**
 * This is to track the Pendency filter options from the backend.
 */
export const PENDENCY_FILTER_OPTIONS_QUERY_KEY =
  'pendency-filter-options-query';

/**
 * This hook fetches the Pendency Filter Options from API.
 */
export const usePendencyFilterOptionsQuery = () => {
  const { data, error, isError, isFetching, isPending, refetch } =
    useQueryWithUserId({
      queryKey: [PENDENCY_FILTER_OPTIONS_QUERY_KEY],
      networkMode: 'always',
      retry: true,
      queryFn: INV_MGMT_SERVICE_API.getPendencyFilterOptions,
    });

  return {
    data,
    error,
    isError,
    isFetching,
    isPending,
    refetch,
  };
};
